import Wrapper from "../../../layout/Wrapper";
import CancelVehicleContractServiceComponent from "../../../screens/approveds/cancelVehicleContract";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Service",
	description: "",
};

export default function AgentService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CancelVehicleContractServiceComponent />
		</Wrapper>
	);
}